/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const imprintStyle = {
  impressum: {
    marginTop: "97px",
  },
};

export default imprintStyle;
